import { useEffect, useState } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'production') {
      return;
    }

    let currentVersion = null;
    
    const getCurrentVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-cache' });
        const data = await response.json();
        currentVersion = data.version;
      } catch (err) {
        console.error('Failed to get current version:', err);
      }
    };
    
    const checkForUpdates = async () => {
      if (!currentVersion) return;
      
      try {
        const response = await fetch('/version.json', { cache: 'no-cache' });
        const data = await response.json();
        
        if (data.version !== currentVersion) {
          setUpdateAvailable(true);
        }
      } catch (err) {
        console.error('Version check failed:', err);
      }
    };
    
    getCurrentVersion();
    const interval = setInterval(checkForUpdates, CHECK_INTERVAL);
    
    return () => clearInterval(interval);
  }, []);

  return updateAvailable;
};

export default useVersionCheck;